import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { SystemMasterSelect } from '../../../Components/helper';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function BtnAddToCareGroup({ onBtnClick, options, handleOpenProductGroup, value }) {
  const { t } = useTranslation('common');

  return (
    <OverlayTrigger
      placement="top"
      trigger="click"
      rootClose
      overlay={
        <Popover className="custom-popover">
          <Popover.Content>
            <div className="d-flex align-items-end">
              <div className="flex-fill mb-0">
                <Select
                  options={options}
                  onChange={onBtnClick}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  styles={SystemMasterSelect}
                  menuPlacement="top"
                  classNamePrefix="common-select"
                  isClearable
                  className="common-select"
                  placeholder={t('CARE_LABELS.BTN_ADD_CARE_GROUP.CARE_LABEL_GROUP')}
                />
              </div>
              <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                <button aria-label={t('COMMON_LABEL.ADD')} type="button" onClick={() => handleOpenProductGroup()} className="btn btn-outline sm ml-16 mr-0">
                  <i className="icon-Add-bold" />
                </button>
              </CustomTooltip>
            </div>
          </Popover.Content>
        </Popover>
      }
    >
      <button
        aria-label={t('CARE_LABELS.BTN_ADD_CARE_GROUP.ADD_TO_CARE_LABEL_GROUP')}
        type="button"
        disabled={value?.length === 0}
        className="btn d-inline-flex"
      >
        <CustomTooltip placement="bottom" tooltipText={t('CARE_LABELS.BTN_ADD_CARE_GROUP.ADD_TO_CARE_LABEL_GROUP')}>
          <i style={{ fontSize: '28px' }} className="icon-Group-1" />
        </CustomTooltip>
      </button>
    </OverlayTrigger>
  );
}

export default BtnAddToCareGroup;
